/**
 * 後台可導航路徑（對齊 V1.0.8__20250602_admin_permission_full.sql 中有 path 的二級選單）
 */
export const MENU_PAGE_PATHS = [
  '/system/auth-manage/role-manage',
  '/system/auth-manage/people-manage',
  '/system/auth-manage/google-captcha',
  '/system/user-manage/user-list',
  '/system/user-manage/kyc-identity-verification',
  '/system/user-manage/user-withdraw-address-list',
  '/system/product-manage/product-list',
  '/system/product-manage/control-specific-user',
  '/system/product-manage/control-global',
  '/system/capital-flow/recharge-list',
  '/system/capital-flow/online-recharge-list',
  '/system/capital-flow/withdrawal-list',
  '/system/capital-flow/transaction-flow',
  '/system/limit-trade/limit-trade-historical-order',
  '/system/perpetual-contract/perpetual-contract-order',
  '/system/perpetual-contract/perpetual-contract-entrustment',
  '/system/fast-contract-manage/fast-contract-order',
  '/system/fast-contract-manage/fast-contract-cycle-record',
  '/system/fast-contract-manage/follow-order',
  '/system/fast-contract-manage/follow-customize-members',
  '/system/statistical-report/user-statistics-report',
  '/system/statistical-report/agency-statistics-report',
  '/system/statistical-report/personal-data-report',
  '/system/statistical-report/im-cs-report',
  '/system/statistical-report/im-chat-report',
  '/system/content-manage/carousel',
  '/system/content-manage/marquee',
  '/system/content-manage/news-info',
  '/system/content-manage/pop-up-announcement',
  '/system/content-manage/announcement-center',
  '/system/content-manage/site-message',
  '/system/content-manage/help-center',
  '/system/content-manage/customer-center-type',
  '/system/content-manage/customer-center-management',
  '/system/content-manage/about-us',
  '/system/content-manage/user-agreement',
  '/system/content-manage/privacy-policy',
  '/system/content-manage/beginner-guide',
  '/system/sticker-manage/pack',
  '/system/sticker-manage/gif',
  '/system/sticker-manage/reaction',
  '/system/im-moderation/reports',
  '/system/system-manage/front-config',
  '/system/system-manage/verification-code-manage',
  '/system/system-manage/system-dic-setting',
  '/system/system-manage/operation-log',
  '/system/system-manage/sms-manage',
  '/system/payment-manage/deposit-withdrawal-param-setting',
  '/system/payment-manage/payment-manage-online-merchant',
  '/system/payment-manage/payment-manage-online-payment-channel',
  '/system/payment-manage/payment-recharge-manage',
  '/system/payment-manage/wallet-address-manage',
  '/system/payment-manage/coin-manage',
  '/system/user-manage/balance-adjust',
  '/system/im-customer-service/feature-switch',
  '/system/im-customer-service/workbench',
  '/system/im-customer-service/supervisor',
  '/system/travel-manage/group-trip-list',
  '/system/travel-manage/trade-list',
  '/system/travel-manage/safety-reports',
  '/system/travel-manage/custom-location-review',
  '/system/ads/review',
  '/system/ads/campaigns',
];
